import {Injectable} from "@angular/core";
import {CanActivate, RouterStateSnapshot} from "@angular/router";
import {CapiLoginService} from 'app/core/extension/login/capi-login-service';

/**
 * Requires users to authenticate when they access protected parts of the ui.
 *
 * You can protect a route by using it as activation guard:
 *
 *     {path: "whatever", component: WhateverComponent, canActivate: [LoginGuard]}
 *
 * Alternatively, you can hide protected parts with *ngIf="loginService.userLoggedIn",
 * and trigger login manually using loginService.requireLogin().
 */
@Injectable()
export class LoginGuard implements CanActivate {

  constructor(private loginService: CapiLoginService) {
  }

  canActivate(route, state: RouterStateSnapshot) {
    return this.loginService.requireLogin(state.url);
  }
}
